import React, { useCallback, useState, useMemo } from 'react';

import config from 'config';
import PropTypes from 'prop-types';

import { Component as PaypalSnippet } from '../PaypalSnippet';

const Context = React.createContext(false);

function PayPalLoader({ children }) {
  const [isPayPalReady, setIsPayPalReady] = useState(false);

  // only retrieve the config value once but make it modifiable for unit tests
  const isPayPalEnabled = useMemo(
    () => config.get('public.paypal.enabled'),
    []
  );

  const handleReady = useCallback(() => {
    setIsPayPalReady(true);
  }, []);

  return (
    <Context.Provider value={isPayPalReady}>
      {isPayPalEnabled ? <PaypalSnippet onReady={handleReady} /> : null}
      {children}
    </Context.Provider>
  );
}

PayPalLoader.propTypes = {
  children: PropTypes.node,
};

PayPalLoader.Context = Context;

export default PayPalLoader;
